import { Link } from "react-router-dom";

export function ClientLink({ id, children }: { id: string; children: React.ReactNode }) {
  return <Link to={`/clients/${id}`}>{children}</Link>;
}

export function PolicyLink({ id, children }: { id: string; children: React.ReactNode }) {
  return <Link to={`/policies/${id}`}>{children}</Link>;
}

export function ClaimLink({ id, children }: { id: string; children: React.ReactNode }) {
  return <Link to={`/claims/${id}`}>{children}</Link>;
}

export function RenewalsLink({ children }: { children: React.ReactNode }) {
  return <Link to="/renewals">{children}</Link>;
}
